export default __webpack_public_path__ + "static/media/mobBannerDAD.1ff4343a.jpg";